<template>
    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <form class="modal-content" v-on:submit.prevent="submit">
                <div class="block block-rounded block-transparent mb-0">
                    <div class="block-header block-header-default">
                        <h3 class="block-title">Move Time Entry</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div v-if="loading" class="block-content text-center">
                        <p class="h4 mb-4">Loading</p>
                    </div>
                    <div v-show="loading === false" class="block-content fs-sm">
                        <template v-if="!loading">
                            <p><strong>Description</strong><br>{{ timeEntry.description }}</p>
                            <p><strong>Staff</strong><br>{{ timeEntry.staff_name }}</p>
                            <p><strong>Start</strong><br>{{ timeEntry.start.full }}</p>
                            <p><strong>End</strong><br>{{ timeEntry.end.full }}</p>
                        </template>

                        <div class="mb-4">
                            <label class="form-label" for="f_vehicle">Vehicle (required)</label>
                            <select class="form-select" id="f_vehicle" ref="vehiclePicker" required>
                            </select>
                        </div>
                        <div class="mb-4">
                            <label class="form-label" for="f_job">Job (optional)</label>
                            <select class="form-select" id="f_job" ref="jobPicker" :disabled="chosenVehicle === null">
                            </select>
                        </div>
                    </div>
                    <div class="block-content block-content-full text-end bg-body">
                        <button type="button" class="btn btn-sm btn-alt-secondary me-1" data-bs-dismiss="modal">Close</button>
                        <button v-if="!loading" type="submit" class="btn btn-sm btn-success">Move</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        routes: Object,
    },
    data () {
        return {
            chosenJob: null,
            chosenVehicle: null,
            errors: {},
            initialisedSelect2: false,
            loading: true, // don't render the page before the data is here
            modal: null,
            timeEntry: {},
            timeEntryUuid: null,
        };
    },
    mounted () {
        this.modal = new Modal(this.$el);

        Eventbus.on('move-classics-timeentry', (timeEntryUuid) => {
            this.initialisedSelect2 = false;
            this.loading = true;
            this.timeEntryUuid = timeEntryUuid;

            axios.get(this.routes.edit.replace('replace-me', this.timeEntryUuid))
                .then((response) => {
                    this.timeEntry = response.data;
                    this.loading = false;
                    this.modal.show();
                    this.initialiseSelect2();
                });
        });
    },
    methods: {
        initialiseSelect2 () {
            if (this.initialisedSelect2) {
                return;
            }

            this.initialisedSelect2 = true;

            setTimeout(() => {
                window.jQuery(this.$refs.vehiclePicker).select2({
                    dropdownParent: this.$el,
                    placeholder: 'Select vehicle',
                    allowClear: true,
                    ajax: {
                        cache: true,
                        data: function(params) {
                            return {
                                search: params.term,
                                page: params.page
                            };
                        },
                        dataType: 'json',
                        delay: 250,
                        processResults: function(data) {
                            // why do we need to do this?
                            return {
                                results: data.data
                            };
                        },
                        url: this.routes.vehicleFilter,
                    }
                }).on('select2:select', (ev) => {
                    this.chosenVehicle = ev.params.data.id;
                    window.jQuery(this.$refs.jobPicker).val(null).trigger('change');
                }).on('select2:clear', (ev) => {
                    this.chosenVehicle = null;
                    window.jQuery(this.$refs.jobPicker).val(null).trigger('change');
                });

                window.jQuery(this.$refs.jobPicker).select2({
                    dropdownParent: this.$el,
                    placeholder: 'Select job',
                    allowClear: true,
                    ajax: {
                        cache: true,
                        data: function(params) {
                            return {
                                search: params.term,
                                page: params.page
                            };
                        },
                        dataType: 'json',
                        delay: 250,
                        processResults: function(data) {
                            // why do we need to do this?
                            return {
                                results: data.data
                            };
                        },
                        url: () => {
                            return this.routes.jobsFilter.replace('replace-me', this.chosenVehicle);
                        },
                    }
                }).on('select2:select', (ev) => {
                    this.chosenJob = ev.params.data.id;
                }).on('select2:clear', (ev) => {
                    this.chosenJob = null;
                });
            }, 50);
        },
        submit () {
            this.loading = true;
            axios.post(this.routes.assignToVehicle.replace('replace-me', this.timeEntryUuid), {
                chosenJob: this.chosenJob,
                chosenVehicle: this.chosenVehicle,
            }).then((response) => {
                if (response.data.success === true) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Moved time entry',
                        timer: 1500,
                        timerProgressBar: true,
                        showConfirmButton: false,
                    });
                    this.modal.hide();
                    Eventbus.emit('time-entries-table-refresh');
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Could not move time entry',
                        text: 'Unknown error',
                    });
                }
            }).catch((error) => {
                let status = 'Unknown';
                if (error.response) {
                    status = error.response.status;
                }

                if (status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Could not move time entry',
                        text: 'System error: ' + status,
                    });
                }
            }).then(() => {
                this.loading = false;
            });
        }
    },
};
</script>
